import { LogGroup, Size } from "../MyHelpers";
import { PixiSpriteResource } from "../ResourceManager/PixiSpriteResource";
import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../ResourceManager/ResourceManager";
import { CanvasSprite } from "./Sprite/CanvasSprite";
import { ITranslatedCanvasParams, TranslatedCanvasSprite } from "./TranslatedCanvasSprite";



export class CommonTranslatedSprite extends TranslatedCanvasSprite {
    constructor ( params : ITranslatedCanvasParams  ){
        super( params )
    }

    public override PrepareResources ( resourceManager : IWriteOnlyResourceManager){
        for (let lang of this.translator.availableLanguages) {
            resourceManager.AddGlobal(new PixiSpriteResource(this.pathSprite +"_"+lang.localityShort, ResourceIdentifier.Global.Add(this.nameSlideSprite +"-"+ lang.localityShort), true,  LogGroup.Global.Add(this.nameSlideSprite+"-"+ lang.localityShort), true));
            //this.resourceManager.AddGlobal(new PixiSpriteResource(`${Settings.ResourcesFolder}multigame/slot/${game.name}/resources/title_sprite2`, ResourceIdentifier.Global.Add(name).Add("title"), true, this.logGroup.Add(name).Add("title"), true));
        }
    }
    public override ResourcesLoaded ( resourceManager : IReadOnlyResourceManager ){
        for (let lang of this.translator.availableLanguages) {
            let sprite = resourceManager.Get<PixiSpriteResource>(ResourceIdentifier.Global.Add(this.nameSlideSprite +"-"+ lang.localityShort)).sprite.Copy();
            this.languagesSprite.set(lang.localityShort, sprite);
        }
        this.canvasSprite = new CanvasSprite({sprite: this.languagesSprite.get(this.translator.t.localityShort), canvasSize: new Size(this.viewSize.Width, this.viewSize.Height)});
        this.translator.SetOnLanguageChangedCallback(() => {
            let currentLanguje = this.translator.t.localityShort;
            this.canvasSprite.ChangeSprite(this.languagesSprite.get(currentLanguje));
            this.canvasSprite.Update(true);
        });
    }    
}
